import React from "react";
import "../Page.css";
import "./style.css";
import google_search_logo from "../../Assets/integration/google_search_console.svg"
import meta from "../../Assets/integration/meta.png";
import KeyValueBox from "./keyValueBox/keyValueBox";
import CodeBox from "./codeBoxComponent/codeBox";

const Meta = () => {
  const codeSnippet = `<!-- Google Tag Manager (Head) -->
<script>
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
var f=d.getElementsByTagName(s)[0], j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:''; 
j.async=true; j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-XXXXXXX');</script>
<!-- End Google Tag Manager -->

<!-- Google Tag Manager (Body) -->
<noscript>
  <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-XXXXXXX"
  height="0" width="0" style="display:none;visibility:hidden"></iframe>
</noscript>
<!-- End Google Tag Manager -->
`;

  return (
    <div className="DashboardPage" style={{ alignItems: "start", justifyContent: "start" }}>
      <div className="component-card">
        <div className="header_integration">
          <div className="name_header_int">
            
            <div className="int_heading_content">
            <h4>Meta Shop</h4>
              <span className="active_state active">Active</span>
              
            </div>
            
          </div>
          <img className="int_logo" src={meta} />
          
        </div>

        <KeyValueBox label={"Pixel ID"} value={"YOUR_VERIFICATION_CODE_HERE"} />
      </div>
    </div>
  );
};

export default Meta;